export default `
  mutation adminUpdateOrganisationAiSettings($id: String!, $adminAllowedAiVersions: [Int]) {
    adminUpdateOrganisationAiSettings(id: $id, adminAllowedAiVersions: $adminAllowedAiVersions) {
      id
      adminAllowedAiVersions
      updatedAt
    }
  }
`
